module.exports = __webpack_public_path__ + "img/FLECHE_DROITE_ACTIVE.903ce929.svg";